
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5295_4364)"}},[_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#E61845"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M37 1.5C37 2.32843 37.6716 3 38.5 3C39.3284 3 40 2.32843 40 1.5C40 0.671573 39.3284 0 38.5 0C37.6716 0 37 0.671573 37 1.5ZM36 37.5C36 38.3284 36.6716 39 37.5 39C38.3284 39 39 38.3284 39 37.5C39 36.6716 38.3284 36 37.5 36C36.6716 36 36 36.6716 36 37.5ZM1.5 40C0.671573 40 0 39.3284 0 38.5C0 37.6716 0.671573 37 1.5 37C2.32843 37 3 37.6716 3 38.5C3 39.3284 2.32843 40 1.5 40Z","fill":"#16171F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.4063 10.4062C10.9479 9.8646 11.826 9.8646 12.3676 10.4062L20 18.0386L27.6324 10.4062C28.174 9.8646 29.0521 9.8646 29.5937 10.4062C30.1353 10.9478 30.1353 11.8259 29.5937 12.3675L21.9613 19.9999L29.5939 27.6325C30.1355 28.1741 30.1355 29.0522 29.5939 29.5938C29.0523 30.1354 28.1742 30.1354 27.6326 29.5938L20 21.9612L12.3674 29.5938C11.8258 30.1354 10.9477 30.1354 10.4061 29.5938C9.86451 29.0522 9.86451 28.1741 10.4061 27.6325L18.0387 19.9999L10.4063 12.3675C9.86466 11.8259 9.86466 10.9478 10.4063 10.4062Z","fill":"white"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_5295_4364"}},[_c('rect',{attrs:{"width":"40","height":"40","fill":"white"}})])])])
          )
        }
      }
    